import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserStore } from '../stores/user.store';
import { isProfileComplete } from '../../shared/utils/profile-photo.utils';
import { redirectBasedOnRole } from '../../shared/utils/route.utils';

/** Profile setup page is only reachable while the username or photo is still missing. */
export const profileIncompleteGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  const user = userStore.user();
  if (!isProfileComplete(user)) {
    return true;
  }

  redirectBasedOnRole(router, user ?? undefined);
  return false;
};
